export const MOCK_ALLOCATION_DETAILS = {
  // Scenario 1: Reserved (In future, eligible for revoke request)
  "1": {
    header: {
      allocationId: "1",
      reference: "ALC-0027",
      status: "Reserved",
      date: "2026-07-16",
      customerName: "Sri Murugan Electricals",
      invoiceNumber: "INV-SME-0523",
      invoiceDate: "2026-07-15",
      deliveryDate: "2026-08-24", // Future (relative to Aug 4, 2026)
      iofNumber: "—",
      createdBy: "Inventory Manager Admin",
      createdOn: "2026-07-16 11:34 AM",
    },
    products: [
      {
        id: "prod-101",
        name: "MCB 32A C-Curve 3-Pole",
        partNumber: "LS-MCB-32C3",
        manufacturer: "Lakshmi Switchgear Industries",
        requestedQty: 300,
        allocatedQty: 300,
        shortfall: 0,
        allocationMethod: "FEFO",
        status: "Reserved",
        batches: [
          {
            batchNumber: "LS-2605-A",
            warehouse: "Coimbatore Central Warehouse",
            allocatedQty: 60,
            warrantyEndDate: "2026-12-31",
          },
          {
            batchNumber: "LS-2607-B",
            warehouse: "Coimbatore Central Warehouse",
            allocatedQty: 240,
            warrantyEndDate: "2027-04-30",
          },
        ],
      },
    ],
    summary: {
      productsCount: 1,
      requestedQty: 300,
      allocatedQty: 300,
      shortfallQty: 0,
      allocationStatus: "Reserved",
      numWarehouses: 1,
    },
  },

  // Scenario 2: Partially Allocated
  "2": {
    header: {
      allocationId: "2",
      reference: "ALC-0028",
      status: "Partially Allocated",
      date: "2026-07-28",
      customerName: "Tata Power Enterprises Ltd",
      invoiceNumber: "INV-TPE-8899",
      invoiceDate: "2026-07-27",
      deliveryDate: "2026-08-10", // Future
      iofNumber: "IOF-TATA-776",
      createdBy: "Inventory Manager Admin",
      createdOn: "2026-07-28 09:15 AM",
    },
    products: [
      {
        id: "prod-102",
        name: "Submersible Pump Type A",
        partNumber: "WP-SUB-A01",
        manufacturer: "Kirloskar Brothers Ltd",
        requestedQty: 120,
        allocatedQty: 95,
        shortfall: 25,
        allocationMethod: "FIFO",
        status: "Partially Allocated",
        batches: [
          {
            batchNumber: "B-PMP-001",
            warehouse: "Warehouse Bangalore",
            allocatedQty: 40,
            warrantyEndDate: "2025-11-30",
          },
          {
            batchNumber: "B-PMP-002",
            warehouse: "Warehouse Mysore",
            allocatedQty: 30,
            warrantyEndDate: "2026-03-31",
          },
          {
            batchNumber: "B-PMP-003",
            warehouse: "Warehouse Chennai",
            allocatedQty: 25,
            warrantyEndDate: null,
          },
        ],
      },
    ],
    summary: {
      productsCount: 1,
      requestedQty: 120,
      allocatedQty: 95,
      shortfallQty: 25,
      allocationStatus: "Partially Allocated",
      numWarehouses: 3,
    },
  },

  // Scenario 3: Delivered (Delivery date is in the past, no revoke action)
  "3": {
    header: {
      allocationId: "3",
      reference: "ALC-0025",
      status: "Delivered",
      date: "2026-07-10",
      customerName: "L&T Construction Group",
      invoiceNumber: "INV-LNT-0112",
      invoiceDate: "2026-07-09",
      deliveryDate: "2026-07-25", // Past
      iofNumber: "—",
      createdBy: "Storekeeper Coimbatore",
      createdOn: "2026-07-10 03:45 PM",
    },
    products: [
      {
        id: "prod-103",
        name: "Gate Valve DN100 PN16",
        partNumber: "FL-GVAL-100",
        manufacturer: "L&T Valves Ltd",
        requestedQty: 10,
        allocatedQty: 10,
        shortfall: 0,
        allocationMethod: "FIFO",
        status: "Delivered",
        batches: [
          {
            batchNumber: "B-VAL-001",
            warehouse: "Coimbatore Central Warehouse",
            allocatedQty: 10,
            warrantyEndDate: "2027-05-18",
          },
        ],
      },
    ],
    summary: {
      productsCount: 1,
      requestedQty: 10,
      allocatedQty: 10,
      shortfallQty: 0,
      allocationStatus: "Delivered",
      numWarehouses: 1,
    },
  },

  // Scenario 4: Revoked
  "4": {
    header: {
      allocationId: "4",
      reference: "ALC-0026",
      status: "Revoked",
      date: "2026-07-12",
      customerName: "Coimbatore Municipal Corp",
      invoiceNumber: "INV-CMC-7756",
      invoiceDate: "2026-07-12",
      deliveryDate: "2026-08-15", // Future
      iofNumber: "—",
      createdBy: "Inventory Manager Admin",
      createdOn: "2026-07-12 04:10 PM",
    },
    products: [
      {
        id: "prod-104",
        name: "LED Panel Light 15W 6500K",
        partNumber: "LT-PAN-15W",
        manufacturer: "Philips Lighting India",
        requestedQty: 80,
        allocatedQty: 80,
        shortfall: 0,
        allocationMethod: "FEFO",
        status: "Revoked",
        batches: [
          {
            batchNumber: "B-LED-001",
            warehouse: "Peelamedu Depot",
            allocatedQty: 80,
            warrantyEndDate: "2026-12-31",
          },
        ],
      },
    ],
    summary: {
      productsCount: 1,
      requestedQty: 80,
      allocatedQty: 80,
      shortfallQty: 0,
      allocationStatus: "Revoked",
      numWarehouses: 1,
    },
  },
};
